import React from "react";

import { usePressTitleRegexInformation } from "@api/pressTitleRegex/pressTitleRegex";

import * as S from "./LabelingPressTitle.style";

const LabelingPressTitle = ({ title }: { title: string }) => {
  const { data: pressTitleRegexInformation } = usePressTitleRegexInformation();

  let labeledTitle = title.replace(/</g, "&lt;").replace(/>/g, "&gt;");

  if (pressTitleRegexInformation) {
    labeledTitle = pressTitleRegexInformation
      .reduce((acc, { regex, keywordColor }) => {
        return acc.replace(
          regex,
          (match) =>
            `<span class="press-title-keyword" style="--keyword-color: ${keywordColor}">${match}</span>`,
        );
      }, labeledTitle)
      // NOTE: 정규식 중에 앞 뒤 #이 있는 경우에 대한 처리가 있어, css 색상 코드로 인해 해당 정규식이 이상하게 동작하는 경우가 있어, css 색상 코드에서 다시 #을 붙여주는 로직을 추가함
      .replaceAll("--keyword-color: ", "--keyword-color: #");
  }

  // eslint-disable-next-line react/no-danger
  return <S.LabelingTitle dangerouslySetInnerHTML={{ __html: labeledTitle }} />;
};

export default LabelingPressTitle;
